import { useState, useEffect } from "react";
import AutoComplete from "../../material/autoComplete/AutoComplete";
import * as publicApi from "../../../service/publicApi";

const LabRegistration = ({ labId, setLabId }) => {
  const [labList, setLabList] = useState([]);

  const getLaboratoryList = async () => {
    try {
      let res = await publicApi.getLaboratoryList();
      if (res["data"]["code"] === 200) {
        setLabList(
          res["data"]["laboratory_list"].map((item) => {
            return {
              id: item["laboratory_id"],
              name: item["laboratory_name"],
              detail: `admin : ${item["admin"]["pname"]}${item["admin"]["fname"]} ${item["admin"]["lname"]}`,
            };
          }),
        );
      }
    } catch (error) {
      console.error("Error Laboratory catch");
    }
  };

  useEffect(() => {
    const fetchAPI = async () => {
      await getLaboratoryList();
    };

    fetchAPI();
  }, []);

  return (
    <div className="max-w-[1000px] mx-auto mt-8">
      <div className="text-[16px] leading-6 text-[#2E2E2E] font-medium mb-5">
        เลือกห้องปฏิบัติการที่สังกัด
      </div>

      <AutoComplete
        id={labId}
        label="ชื่อแลป"
        placeholder="ชื่อแลป"
        list={labList}
        callBack={(res) => {
          setLabId(res["id"]);
        }}
      ></AutoComplete>
    </div>
  );
};

export default LabRegistration;
